import useWindowSize from './useWindowSize';

export default useWindowSize;
